var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_once" }, [
      _c("p", { staticClass: "p" }, [_vm._v("如何创建文件发起审批")]),
      _c("p", { staticClass: "text" }, [
        _vm._v("1.在首页中点击“企业控制台”进入企业管理界面；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img10.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v("2.点击“成员合同审批”，进入文件发起时审批页面，点击新增审批；")
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img11.png", alt: "" }
      }),
      _c("p", { staticClass: "text" }, [
        _vm._v(
          "3.根据页面展示，填写对应内容或选择对应选项，点击确定即可创建成功。（若使用范围未选择，则全体企业成员在合同发起时均可选择使用此流程）"
        )
      ]),
      _c("img", {
        staticClass: "img",
        attrs: { src: "/images/home/sign_img12.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bade132", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bade132","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/dingtalkUse/helpCenterCom/4_apprFile.vue
// module id = o6hd
// module chunks = 54 239